import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Paper,
  Typography,
  IconButton,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  Tooltip,
  Chip,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ListAltIcon from "@material-ui/icons/ListAlt";
import AndroidIcon from "@material-ui/icons/Android";
import GroupIcon from "@material-ui/icons/Group";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ForumIcon from "@material-ui/icons/Forum";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import api from "../../services/api";
import {
  situacaoDaConexao,
  formatarNumeroConexao,
} from "../../utils/statusConexao";
import { toast } from "react-toastify";
import openSocket from "../../services/socket-io";
import { PainelConexoes, estaNoAr } from "../../components/SeletorConexoes";
import { bannerAstro, cartaoAstro } from "../../utils/estiloAstro";
import ButtonBase from "@material-ui/core/ButtonBase";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import {
  VERDE,
  bannerNavy,
  bannerTitulo,
  bannerSub,
  bannerStats,
  bannerStat,
  bannerStatValor,
  bannerStatRotulo,
  botaoVerdeBrilho,
  modalPapel,
  modalHero,
  modalHeroLinha,
  modalHeroIcone,
  modalHeroEtiqueta,
  modalHeroTitulo,
  modalHeroSub,
  modalFechar,
  modalCorpo,
  modalRodape,
  campoNavy,
  botaoPrimario,
  botaoSecundario
} from "../../utils/estiloNavy";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(3),
    margin: theme.spacing(2),
    overflowY: "scroll",
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    ...theme.scrollbarStyles,
  },
  header: {
    ...bannerNavy(theme),
    marginBottom: theme.spacing(3)
  },
  headerTopo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12
  },
  bannerTitulo,
  bannerSub,
  bannerIcone: {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg,#22c55e,#15803d)",
    boxShadow: "0 6px 18px rgba(34,197,94,.35)"
  },
  bannerStats,
  bannerStat,
  bannerStatValor,
  bannerStatRotulo,
  botaoVerdeBrilho,
  cardIcone: {
    width: 40,
    height: 40,
    borderRadius: 12,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    background: "linear-gradient(135deg,#22c55e,#15803d)",
    boxShadow: "0 6px 16px rgba(34,197,94,.3)",
    "& svg": { fontSize: 20 }
  },
  cardSub: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: 2
  },
  pilulaEstado: {
    fontSize: 10.5,
    fontWeight: 800,
    borderRadius: 999,
    padding: "2px 8px",
    display: "inline-flex",
    alignItems: "center",
    gap: 5
  },
  resumoConexoes: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 12,
    justifyContent: "flex-start",
    textAlign: "left",
    marginBottom: theme.spacing(1.5),
    padding: "10px 12px",
    borderRadius: 14,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#f8fbf9",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.07)" : "#e6f0ea"}`,
    transition: "border-color .15s, box-shadow .15s",
    "&:hover": {
      borderColor: "rgba(30,152,85,0.45)",
      boxShadow: "0 6px 16px -10px rgba(30,152,85,0.7)",
      "& $resumoSeta": { transform: "translateX(3px)", color: VERDE }
    }
  },
  pilha: { display: "flex", alignItems: "center", flexShrink: 0 },
  bolinha: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    color: "#fff",
    background: "linear-gradient(135deg,#22c55e,#15803d)",
    border: `2px solid ${theme.palette.background.paper}`,
    "& svg": { fontSize: 15 },
    "&:not(:first-child)": { marginLeft: -9 }
  },
  bolinhaMais: {
    background: theme.palette.type === "dark" ? "#1f2724" : "#e2e8f0",
    color: theme.palette.text.primary,
    fontSize: 11,
    fontWeight: 800
  },
  bolinhaVazia: {
    background: theme.palette.type === "dark" ? "#1f2724" : "#eef2f6",
    color: "#94a3b8"
  },
  resumoTexto: { flex: 1, minWidth: 0 },
  resumoTitulo: { fontSize: 13, fontWeight: 800, color: theme.palette.text.primary },
  resumoSub: { fontSize: 11.5, color: theme.palette.text.secondary, display: "flex", gap: 8, flexWrap: "wrap" },
  resumoSeta: { color: theme.palette.text.disabled, transition: "transform .15s, color .15s" },
  papelModal: modalPapel(theme, 460),
  heroModal: modalHero(theme),
  heroLinha: modalHeroLinha,
  heroIcone: modalHeroIcone,
  heroEtiqueta: modalHeroEtiqueta,
  heroTitulo: modalHeroTitulo,
  heroSub: modalHeroSub,
  fecharModal: { ...modalFechar, marginLeft: "auto", alignSelf: "flex-start" },
  corpoModal: modalCorpo(theme),
  rodapeModal: { ...modalRodape(theme), justifyContent: "flex-end" },
  campoNavy: campoNavy(theme),
  btnPrimario: botaoPrimario,
  btnSecundario: botaoSecundario(theme),
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: theme.spacing(2.5)
  },
  card: {
    ...cartaoAstro(theme),
    padding: theme.spacing(2.5, 2.5, 2),
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1)
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: 16,
    color: theme.palette.text.primary,
    wordBreak: "break-word",
    paddingRight: theme.spacing(1)
  },
  blockCount: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.type === "dark" ? "rgba(34,197,94,0.16)" : "#e3f6ea",
    color: theme.palette.type === "dark" ? "#86efac" : "#15803d",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(34,197,94,0.16)" : "#e3f6ea"
    }
  },
  flowStrip: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 4,
    minHeight: 32,
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1, 1.25),
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#f1f7f3",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "#e6f0ea"}`,
  },
  flowIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 28,
    height: 28,
    borderRadius: "50%",
    flexShrink: 0,
    transition: "transform .2s ease",
    // os ícones do fluxo "pulam" em sequência ao passar o mouse no cartão
    "$card:hover &": { transform: "translateY(-3px) scale(1.08)" },
  },
  flowArrow: {
    fontSize: 12,
    color: theme.palette.text.disabled,
    flexShrink: 0
  },
  flowEmpty: {
    fontSize: 12,
    color: theme.palette.text.disabled,
    fontStyle: "italic"
  },
  whatsSection: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1, 1.25),
    borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.02)" : "#fafcfb",
    border: `1px dashed ${theme.palette.divider}`
  },

  tituloConexoes: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },

  chipConexao: {
    fontSize: 11,
    height: 22,
    fontWeight: 600,
    backgroundColor: theme.palette.type === "dark"
      ? "rgba(52,211,153,0.18)"
      : "#E8F5E9",
    color: theme.palette.type === "dark" ? "#6ee7b7" : "#2E7D32",
  },
  semConexao: {
    color: theme.palette.text.secondary,
    fontStyle: "italic",
  },
  whatsChips: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
    marginTop: 2
  },
  cardFooter: {
    marginTop: "auto",
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  actions: {
    display: "flex",
    gap: 4,
    "& .MuiIconButton-root": {
      borderRadius: 9,
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#f3f7f4",
      "&:hover": { backgroundColor: "rgba(30,152,85,0.14)", color: "#1E9855" },
    },
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(8, 2),
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  emptyIcon: {
    fontSize: 56,
    color: "#22c55e",
    marginBottom: theme.spacing(2),
    animation: "iaFlutuar 4s ease-in-out infinite",
  }
}));

const NODE_META = {
  startNode: { icon: PlayCircleFilledIcon, color: "#1E9855", label: "Início" },
  textNode: { icon: ChatBubbleOutlineIcon, color: "#1976d2", label: "Mensagem" },
  menuNode: { icon: ListAltIcon, color: "#f57c00", label: "Menu" },
  aiNode: { icon: AndroidIcon, color: "#9c27b0", label: "IA" },
  queueNode: { icon: GroupIcon, color: "#e65100", label: "Fila" },
  delayNode: { icon: AccessTimeIcon, color: "#00838f", label: "Espera" }
};

const getFlowSteps = (flowDataStr) => {
  try {
    const flow = JSON.parse(flowDataStr || "{}");
    const nodes = flow.nodes || [];
    const edges = flow.edges || [];
    if (!nodes.length) return [];

    const start = nodes.find((n) => n.type === "startNode") || nodes[0];
    const steps = [];
    const visited = new Set();
    let current = start;

    while (current && !visited.has(current.id) && steps.length < 7) {
      visited.add(current.id);
      steps.push(current.type);
      const edge = edges.find((e) => e.source === current.id);
      if (!edge) break;
      current = nodes.find((n) => n.id === edge.target);
    }

    return steps;
  } catch (e) {
    return [];
  }
};

const countBlocks = (flowDataStr) => {
  try {
    const flow = JSON.parse(flowDataStr || "{}");
    const nodes = flow.nodes || [];
    return nodes.filter((n) => n.type !== "startNode").length;
  } catch (e) {
    return 0;
  }
};

const FlowPreview = ({ flowData, classes }) => {
  const steps = useMemo(() => getFlowSteps(flowData), [flowData]);

  if (!steps.length) {
    return (
      <div className={classes.flowStrip}>
        <span className={classes.flowEmpty}>Fluxo ainda vazio — abra o construtor para montar.</span>
      </div>
    );
  }

  return (
    <div className={classes.flowStrip}>
      {steps.map((type, index) => {
        const meta = NODE_META[type] || { icon: ForumIcon, color: "#9e9e9e", label: type };
        const Icon = meta.icon;
        return (
          <React.Fragment key={index}>
            {index > 0 && <ArrowForwardIcon className={classes.flowArrow} />}
            <Tooltip title={meta.label}>
              <div className={classes.flowIcon} style={{ backgroundColor: `${meta.color}22` }}>
                <Icon style={{ fontSize: 15, color: meta.color }} />
              </div>
            </Tooltip>
          </React.Fragment>
        );
      })}
    </div>
  );
};

const Chatbots = () => {
  const classes = useStyles();
  const history = useHistory();
  const [chatbots, setChatbots] = useState([]);
  const [allWhatsapps, setAllWhatsapps] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [newChatbotName, setNewChatbotName] = useState("");
  const [editingChatbotId, setEditingChatbotId] = useState(null);

  const [connModalChatbot, setConnModalChatbot] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [chatRes, whatsRes] = await Promise.all([
        api.get("/chatbots"),
        api.get("/whatsapp")
      ]);
      setChatbots(chatRes.data || []);
      setAllWhatsapps(whatsRes.data || []);
    } catch (err) {
      toast.error("Erro ao carregar dados de fluxos e conexões.");
    }
  };

  const handleOpenDialog = () => {
    setNewChatbotName("");
    setEditingChatbotId(null);
    setOpenDialog(true);
  };

  const handleOpenEditDialog = (chatbot) => {
    setNewChatbotName(chatbot.name);
    setEditingChatbotId(chatbot.id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingChatbotId(null);
  };

  const handleSave = async () => {
    if (!newChatbotName.trim()) return;
    try {
      if (editingChatbotId) {
        await api.put(`/chatbots/${editingChatbotId}`, { name: newChatbotName });
        toast.success("Nome do chatbot atualizado.");
        fetchData();
        handleCloseDialog();
      } else {
        const { data } = await api.post("/chatbots", { name: newChatbotName, flowData: "{}" });
        handleCloseDialog();
        history.push(`/fluxos-visuais/${data.id}/builder`);
      }
    } catch (err) {
      toast.error("Erro ao salvar chatbot.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Deseja realmente excluir este chatbot?")) return;
    try {
      await api.delete(`/chatbots/${id}`);
      fetchData();
      toast.success("Chatbot excluído.");
    } catch (err) {
      toast.error("Erro ao excluir.");
    }
  };

  const handleToggleActive = async (chatbot) => {
    try {
      await api.put(`/chatbots/${chatbot.id}`, { active: !chatbot.active });
      fetchData();
      toast.success(chatbot.active ? "Chatbot desativado." : "Chatbot ativado.");
    } catch (err) {
      toast.error("Erro ao alterar status do chatbot.");
    }
  };

  const handleOpenConnModal = (chatbot) => {
    setConnModalChatbot(chatbot);
  };

  const handleCloseConnModal = () => {
    setConnModalChatbot(null);
  };

  // Cada chave do painel ja salva no servidor; aqui so refletimos na tela.
  const atualizarConexaoLocal = (whatsId, novoChatbotId) => {
    setAllWhatsapps((lista) =>
      lista.map((w) => (w.id === whatsId ? { ...w, chatbotId: novoChatbotId } : w))
    );
  };

  // Status ao vivo das conexoes (caiu / voltou) sem recarregar.
  useEffect(() => {
    const socket = openSocket();
    const aoMudarConexao = (data) => {
      if (data.action === "update" && data.whatsapp) {
        setAllWhatsapps((lista) => {
          const existe = lista.some((w) => w.id === data.whatsapp.id);
          return existe
            ? lista.map((w) => (w.id === data.whatsapp.id ? { ...w, ...data.whatsapp } : w))
            : [data.whatsapp, ...lista];
        });
      }
      if (data.action === "delete") {
        setAllWhatsapps((lista) => lista.filter((w) => w.id !== data.whatsappId));
      }
    };
    const aoMudarSessao = (data) => {
      if (data.action === "update" && data.session) {
        setAllWhatsapps((lista) =>
          lista.map((w) => (w.id === data.session.id ? { ...w, status: data.session.status } : w))
        );
      }
    };
    socket.on("whatsapp", aoMudarConexao);
    socket.on("whatsappSession", aoMudarSessao);
    return () => {
      socket.off("whatsapp", aoMudarConexao);
      socket.off("whatsappSession", aoMudarSessao);
    };
  }, []);

  return (
    <Paper className={classes.mainPaper}>
      <div className={classes.header}>
        <div className={classes.headerTopo}>
          <div>
            <div className={classes.bannerTitulo}>
              <span className={classes.bannerIcone}>
                <AccountTreeIcon />
              </span>
              Fluxos visuais
            </div>
            <div className={classes.bannerSub}>
              Monte o início do atendimento e escolha quais números atendem com cada fluxo.
            </div>
          </div>
          <Button className={classes.botaoVerdeBrilho} onClick={handleOpenDialog}>
            + Novo fluxo
          </Button>
        </div>
        {(() => {
          const ativos = chatbots.filter((c) => c.active).length;
          const atendendo = allWhatsapps.filter((w) => w.chatbotId && estaNoAr(w)).length;
          const fora = allWhatsapps.filter((w) => w.chatbotId && !estaNoAr(w)).length;
          const semFluxo = allWhatsapps.filter((w) => !w.chatbotId && estaNoAr(w)).length;
          return (
            <div className={classes.bannerStats}>
              {[
                { v: `${ativos}/${chatbots.length}`, r: "Fluxos ativos", c: "#4ade80" },
                { v: atendendo, r: "Números atendendo", c: "#4ade80" },
                { v: fora, r: "Fora do ar", c: fora ? "#fbbf24" : "#64748b" },
                { v: semFluxo, r: "No ar sem fluxo", c: "#94a3b8" }
              ].map((x, i) => (
                <div key={x.r} className={classes.bannerStat} style={{ animationDelay: `${i * 60}ms` }}>
                  <div className={classes.bannerStatValor}>{x.v}</div>
                  <div className={classes.bannerStatRotulo}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: x.c }} />
                    {x.r}
                  </div>
                </div>
              ))}
            </div>
          );
        })()}
      </div>

      {chatbots.length === 0 ? (
        <div className={classes.emptyState}>
          <AccountTreeIcon className={classes.emptyIcon} />
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Nenhum fluxo criado ainda
          </Typography>
          <Typography variant="body2" style={{ marginTop: 4, marginBottom: 20, maxWidth: 360 }}>
            Monte o primeiro fluxo visual para automatizar o início do atendimento antes de passar para a IA.
          </Typography>
          <Button variant="contained" color="primary" onClick={handleOpenDialog}>
            + Criar primeiro chatbot
          </Button>
        </div>
      ) : (
        <div className={classes.grid}>
          {chatbots.map((chatbot) => {
            const vinculadas = allWhatsapps.filter((w) => w.chatbotId === chatbot.id);
            const connectedWhatsapps = vinculadas.filter(estaNoAr);
            const foraDoAr = vinculadas.length - connectedWhatsapps.length;

            return (
              <div className={classes.card} key={chatbot.id}>
                <div className={classes.cardHeader}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
                    <span className={classes.cardIcone}>
                      <AccountTreeIcon />
                    </span>
                    <div style={{ minWidth: 0 }}>
                      <Typography className={classes.cardTitle}>{chatbot.name}</Typography>
                      <div className={classes.cardSub}>
                        <span
                          className={classes.pilulaEstado}
                          style={
                            chatbot.active
                              ? { color: VERDE, background: "rgba(30,152,85,0.12)" }
                              : { color: "#64748b", background: "rgba(100,116,139,0.12)" }
                          }
                        >
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: chatbot.active ? "#22c55e" : "#94a3b8" }} />
                          {chatbot.active ? "Ativo" : "Pausado"}
                        </span>
                        {countBlocks(chatbot.flowData)} bloco{countBlocks(chatbot.flowData) === 1 ? "" : "s"}
                      </div>
                    </div>
                  </div>
                  <Tooltip title={chatbot.active ? "Pausar fluxo" : "Ativar fluxo"}>
                    <Switch
                      size="small"
                      checked={chatbot.active}
                      onChange={() => handleToggleActive(chatbot)}
                      color="primary"
                    />
                  </Tooltip>
                </div>

                <FlowPreview flowData={chatbot.flowData} classes={classes} />

                {}
                <Tooltip
                  arrow
                  placement="top"
                  title={
                    connectedWhatsapps.length ? (
                      <div style={{ padding: 2 }}>
                        <b>No ar neste fluxo:</b>
                        {connectedWhatsapps.map((w) => (
                          <div key={w.id}>
                            • {w.name}
                            {formatarNumeroConexao(w.numero) ? ` — ${formatarNumeroConexao(w.numero)}` : ""}
                          </div>
                        ))}
                      </div>
                    ) : (
                      "Nenhum número no ar neste fluxo"
                    )
                  }
                >
                  <ButtonBase className={classes.resumoConexoes} onClick={() => handleOpenConnModal(chatbot)}>
                    <span className={classes.pilha}>
                      {connectedWhatsapps.length === 0 ? (
                        <span className={`${classes.bolinha} ${classes.bolinhaVazia}`}>
                          <WhatsAppIcon />
                        </span>
                      ) : (
                        <>
                          {connectedWhatsapps.slice(0, 4).map((w) => (
                            <span key={w.id} className={classes.bolinha}>
                              <WhatsAppIcon />
                            </span>
                          ))}
                          {connectedWhatsapps.length > 4 && (
                            <span className={`${classes.bolinha} ${classes.bolinhaMais}`}>
                              +{connectedWhatsapps.length - 4}
                            </span>
                          )}
                        </>
                      )}
                    </span>
                    <span className={classes.resumoTexto}>
                      <div className={classes.resumoTitulo}>
                        {connectedWhatsapps.length === 0
                          ? "Nenhum número atendendo"
                          : `${connectedWhatsapps.length} número${connectedWhatsapps.length === 1 ? "" : "s"} atendendo`}
                      </div>
                      <div className={classes.resumoSub}>
                        {foraDoAr > 0 ? (
                          <span style={{ color: "#d97706", fontWeight: 700 }}>
                            {foraDoAr} fora do ar · volta{foraDoAr === 1 ? "" : "m"} sozinho{foraDoAr === 1 ? "" : "s"}
                          </span>
                        ) : (
                          <span>Clique para gerenciar</span>
                        )}
                      </div>
                    </span>
                    <ChevronRightIcon className={classes.resumoSeta} />
                  </ButtonBase>
                </Tooltip>

                <div className={classes.cardFooter}>
                  <Typography variant="caption" color="textSecondary">
                    {chatbot.active ? "Em uso" : "Pausado"}
                  </Typography>
                  <div className={classes.actions}>
                    <Tooltip title="Testar fluxo">
                      <IconButton size="small" style={{ color: "#1E9855" }} onClick={() => history.push(`/fluxos-visuais/${chatbot.id}/builder?sim=1`)}>
                        <PlayArrowIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Construtor (fluxo)">
                      <IconButton size="small" onClick={() => history.push(`/fluxos-visuais/${chatbot.id}/builder`)}>
                        <AccountTreeIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar nome">
                      <IconButton size="small" onClick={() => handleOpenEditDialog(chatbot)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Excluir">
                      <IconButton size="small" onClick={() => handleDelete(chatbot.id)}>
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth={false} PaperProps={{ className: classes.papelModal }}>
        <div className={classes.heroModal}>
          <div className={classes.heroLinha}>
            <div className={classes.heroIcone}>
              <AccountTreeIcon />
            </div>
            <div style={{ minWidth: 0 }}>
              <div className={classes.heroEtiqueta}>Fluxos visuais</div>
              <div className={classes.heroTitulo}>{editingChatbotId ? "Renomear fluxo" : "Novo fluxo"}</div>
              <div className={classes.heroSub}>
                {editingChatbotId ? "Só o nome muda; blocos e números continuam iguais." : "Depois de criar, o construtor abre para você montar os blocos."}
              </div>
            </div>
            <IconButton size="small" className={classes.fecharModal} onClick={handleCloseDialog}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
        </div>
        <div className={classes.corpoModal}>
          <TextField
            autoFocus
            label="Nome do fluxo"
            placeholder="Ex: Catarina, Campanha FGTS..."
            type="text"
            fullWidth
            size="small"
            variant="outlined"
            className={classes.campoNavy}
            value={newChatbotName}
            onChange={(e) => setNewChatbotName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSave()}
          />
        </div>
        <div className={classes.rodapeModal}>
          <Button onClick={handleCloseDialog} className={classes.btnSecundario}>
            Cancelar
          </Button>
          <Button onClick={handleSave} className={classes.btnPrimario} disabled={!newChatbotName.trim()}>
            {editingChatbotId ? "Salvar nome" : "Criar e abrir construtor"}
          </Button>
        </div>
      </Dialog>

      {}
      <Dialog
        open={Boolean(connModalChatbot)}
        onClose={handleCloseConnModal}
        maxWidth={false}
        PaperProps={{ className: classes.papelModal }}
      >
        {connModalChatbot && (
          <PainelConexoes
            compacto
            chatbotId={connModalChatbot.id}
            chatbots={chatbots}
            whatsapps={allWhatsapps}
            onAtualizado={atualizarConexaoLocal}
          />
        )}
        <div className={classes.rodapeModal}>
          <Button onClick={handleCloseConnModal} className={classes.btnPrimario}>
            Concluir
          </Button>
        </div>
      </Dialog>
    </Paper>
  );
};

export default Chatbots;
